import { hc } from 'hono/client';

// In both development and production, the Tenant Gateway API is mounted at /api/* relative to the frontend domain.
export const API_BASE = '/';

export const authFetch = async (input: RequestInfo | URL, init?: RequestInit) => {
  let token = '';
  try {
    const stored = localStorage.getItem('dark_session');
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.token) token = parsed.token;
    }
  } catch(e) {}
  
  const headers = new Headers(init?.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);
  
  const res = await fetch(input, { ...init, headers });

  if (res.status === 401 && typeof window !== 'undefined') {
    const isCrmSubdomain = window.location.hostname === 'crm.dark.tel';
    const path = window.location.pathname;
    const isCrmRoute = isCrmSubdomain || path.startsWith('/services/crm');

    let requestUrl = '';
    if (typeof input === 'string') requestUrl = input;
    else if (input instanceof Request) requestUrl = input.url;
    else if (input instanceof URL) requestUrl = input.toString();
    const isCrmEndpoint = requestUrl.includes('/crm-dashboard/');

    if (!isCrmRoute && !isCrmEndpoint && path !== '/login') {
      try {
        localStorage.removeItem('dark_session');
      } catch (e) {}
      window.location.href = '/login?expired=1';
    }
  }

  return res;
};

export const client: any = hc<any>(API_BASE, {
  fetch: authFetch
});

/**
 * Resolve asset URLs that may be stored as relative paths (e.g. /api/public/assets/...).
 * In dev, relative paths work via Vite proxy. In production, they need the orchestrator origin.
 */
export function resolveAssetUrl(url: string | undefined): string {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:') || url.startsWith('blob:')) {
    return url;
  }
  if (import.meta.env.DEV) return url;
  // If running on dark.tel or localhost in browser, relative paths are native
  if (typeof window !== 'undefined' && (window.location.hostname === 'dark.tel' || window.location.hostname === 'localhost')) {
    return url.startsWith('/') ? url : `/${url}`;
  }
  const base = API_BASE.replace(/\/$/, '');
  return `${base}${url.startsWith('/') ? '' : '/'}${url}`;
}
